
    const env = import.meta.env;
    if (env.DEV) {
      window.MOBILE_VERSION = env.VUE_APP_MOBILE_VERSION;
      window.API_PROXY_URL = env.VUE_APP_API_PROXY_URL;
      window.OPERATION_MODE = env.VUE_APP_OPERATION_MODE;
      window.USAGE_EXPLORER_BETA_USERS = env.VUE_APP_USAGE_EXPLORER_BETA_USERS;
      window.IMPACT_CENTER_ALLOWED_EMAILS =
        env.VUE_APP_IMPACT_CENTER_ALLOWED_EMAILS;
      window.IMPACT_CENTER_PUBLICLY_OPENED =
        env.VUE_APP_IMPACT_CENTER_PUBLICLY_OPENED;
      window.FETCH_RELEASE_NOTES_IS_PUBLIC =
        env.VUE_APP_FETCH_RELEASE_NOTES_IS_PUBLIC;
      window.AI_SCANS_WIDGET_PUBLICLY_OPENED =
        env.VUE_APP_AI_SCANS_WIDGET_PUBLICLY_OPENED;
      window.LANDING_APP_URL = env.VUE_APP_LANDING_APP_URL;
      window.GOOGLE_CLIENT_ID = env.VUE_APP_GOOGLE_CLIENT_ID;
      window.MARKETO_MUNCHKIN_ID = env.VUE_APP_MARKETO_MUNCHKIN_ID;
      window.HEAP_ID = env.VUE_APP_HEAP_ID;
      window.FULLSTORY_ORG_ID = env.VUE_APP_FULLSTORY_ORG_ID;
      window.PLATFORM_DOMAIN = env.VUE_APP_PLATFORM_DOMAIN;
      window.KNOWLEDGE_CENTER_URL = env.VUE_APP_KNOWLEDGE_CENTER_URL;
      window.FIREBASE_API_KEY = env.VUE_APP_FIREBASE_API_KEY;
      window.FIREBASE_AUTH_DOMAIN = env.VUE_APP_FIREBASE_AUTH_DOMAIN;
      window.FIREBASE_PROJECT_ID = env.VUE_APP_FIREBASE_PROJECT_ID;
      window.FIREBASE_STORAGE_BUCKET = env.VUE_APP_FIREBASE_STORAGE_BUCKET;
      window.FIREBASE_MESSAGING_SENDER_ID =
        env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID;
      window.FIREBASE_APP_ID = env.VUE_APP_FIREBASE_APP_ID;
      window.KEYCLOAK_MINUTES_BEFORE_TOKEN_REFRESH =
        env.VUE_APP_KEYCLOAK_MINUTES_BEFORE_TOKEN_REFRESH;
      window.KEYCLOAK_URL = env.VUE_APP_KEYCLOAK_URL;
      window.KEYCLOAK_REALM = env.VUE_APP_KEYCLOAK_REALM;
      window.KEYCLOAK_CLIENT_ID = env.VUE_APP_KEYCLOAK_CLIENT_ID;
      window.SUPPORT_PORTAL_URL = env.VUE_APP_SUPPORT_PORTAL_URL;
    }

    document.title =
      window.OPERATION_MODE === "partner_portal" ? "Partner Portal" : "MyJFrog";

    if (
      !(
        navigator.userAgent.includes("Electron") ||
        navigator.userAgent.includes("Cypress") ||
        import.meta.env.MODE === "test"
      )
    ) {
      window.heap.load(window.HEAP_ID);
    }
  